export default {
  "Política Nacional": "4BD6F7",
  "Legislativas": "F7A334",
  "Frases Memorables": "FB2D11",
  "Latinoamérica": "32F991",
  "Ejecutivo": "E9F92A", 
  "Elecciones 2023": "FC47C9"
};

